import React, {Component} from 'react';
import img from "../../../../../assets/images/journal/j-indicator-sample.jpg"

class JImpactFactor extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: '',
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.meta.jcr_index && nextProps.meta.jcr_index.length > 0) {
			this.setState({
				activeTab: 'jcr'
			});
		} else if (nextProps.meta.scopus_index && nextProps.meta.scopus_index.length > 0) {
			this.setState({
				activeTab: 'scopus'
			})
		} else if (nextProps.meta.kci_index && nextProps.meta.kci_index.length > 0) {
			this.setState({
				activeTab: 'kci'
			})
		}
	}

	changeTab = (id) => {
		this.setState({
			activeTab: id
		})
	}

	render() {
		const meta = this.props.meta;

		if(Object.keys(meta).length === 0)
			return ''
		if (!meta.error_code && !((meta.jcr_index && meta.jcr_index.length > 0) || (meta.scopus_index && meta.scopus_index.length > 0)
			|| (meta.kci_index && meta.kci_index.length > 0)))
			return '';

		return (
			<div className="mt-px-40 journal-detail-impact">
				<div className="d-flex justify-content-between align-items-center mb-px-26">
					<div className="d-flex align-items-center">
						<h3 className="con-title">인용지표</h3>
					</div>
				</div>
				{meta.error_code ?
					<img src={img} style={{width : "100%"}}/>
					:
					<>
						<div className="d-flex align-items-center mb-3 print-none">
							{(meta.jcr_index && meta.jcr_index.length > 0) &&
							<button
								className={"btn-tab-nav mr-1 active-color-lightpurple " + (this.state.activeTab === 'jcr' ? 'active' : '')}
								onClick={() => this.changeTab('jcr')}>JCR</button>}
							{(meta.scopus_index && meta.scopus_index.length > 0) &&
							<button
								className={"btn-tab-nav mr-1 active-color-lightorange " + (this.state.activeTab === 'scopus' ? 'active' : '')}
								onClick={() => this.changeTab('scopus')}>Scopus</button>}
							{(meta.kci_index && meta.kci_index.length > 0) &&
							<button
								className={"btn-tab-nav mr-1 active-color-lightgreen " + (this.state.activeTab === 'kci' ? 'active' : '')}
								onClick={() => this.changeTab('kci')}>KCI</button>}
						</div>
						<div>
							{this.state.activeTab === 'jcr' &&
							<div className="tab-data active print-none">
								<table className="table table-lightgray">
									<colgroup>
										{/*<col width="7%"/>*/}
										{/*<col width="10%"/>*/}
										{/*<col width="10%"/>*/}
										{/*<col width="10%"/>*/}
										{/*<col width="12.6%"/>*/}
										{/*<col width="12.6%"/>*/}
										{/*<col width="12.6%"/>*/}
										{/*<col width="10%"/>*/}
										{/*<col width="12.6%"/>*/}
										<col width="10%"/>
										<col width="15%"/>
										<col width="15%"/>
										<col width="15%"/>
										<col width="15%"/>
										<col width="15%"/>
										<col width="15%"/>
									</colgroup>
									<thead>
									<tr>
										<th scope="col">Year</th>
										<th scope="col">Total<br/>Cites</th>
										<th scope="col">JIF</th>
										<th scope="col">5 year JIF</th>
										<th scope="col">Immediacy<br/>Index</th>
										<th scope="col">Article<br/>Influence Score</th>
										<th scope="col">Eigenfactor<br/>Score</th>
										{/*<th scope="col">보정 IF</th>*/}
										{/*<th scope="col">보정 ES</th>*/}
									</tr>
									</thead>
									<tbody>
									{meta.jcr_index && meta.jcr_index.map((item, num) => {
										return (
											<tr key={num}>
												<td>{item.indicator_year}</td>
												<td>{item.total_cites}</td>
												<td>{item.jif}</td>
												<td>{item.impact_5}</td>
												<td>{item.immediacy}</td>
												<td>{item.article_influence}</td>
												<td>{item.eigen_factor}</td>
												{/*<td>{item.correct_impact}</td>*/}
												{/*<td>{item.correct_eigen}</td>*/}
											</tr>
										)
									})}
									</tbody>
								</table>
							</div>
							}
							{this.state.activeTab === 'scopus' &&
							<div className="tab-data active print-none">
								<table className="table table-lightgray">
									<colgroup>
										<col width="7%"/>
										<col width="11%"/>
										<col width="10%"/>
										<col width="11%"/>
										<col width="12.2%"/>
										<col width="12.2%"/>
										<col width="12.2%"/>
										<col width="12.2%"/>
									</colgroup>
									<thead>
									<tr>
										<th scope="col">Year</th>
										<th scope="col">Percent Cited</th>
										<th scope="col">Cite Score</th>
										<th scope="col">Citation<br/>Count</th>
										<th scope="col">Scholarly<br/>Output</th>
										<th scope="col">SJR</th>
										<th scope="col">Top 10%</th>
										<th scope="col">SNIP</th>
									</tr>
									</thead>
									<tbody>
									{meta.scopus_index && meta.scopus_index.map((item, num) => {
										return (
											<tr key={num}>
												<td>{item.indicator_year}</td>
												<td>{item.percent_cited}</td>
												<td>{item.cite_score}</td>
												<td>{item.citation_count}</td>
												<td>{item.scholarly_output}</td>
												<td>{item.sjr}</td>
												<td>{item.top10}</td>
												<td>{item.snip}</td>
											</tr>
										)
									})}
									</tbody>
								</table>
							</div>
							}
							{this.state.activeTab === 'kci' &&
							<div className="tab-data active print-none">
								<table className="table table-lightgray">
									<colgroup>
										<col width="7%"/>
										<col width="9%"/>
										<col width="9%"/>
										<col width="14%"/>
										<col width="12.2%"/>
										<col width="12.2%"/>
										<col width="12.2%"/>
										<col width="12.2%"/>
										<col width="12.2%"/>
									</colgroup>
									<thead>
									<tr>
										<th scope="col">Year</th>
										<th scope="col">논문수</th>
										<th scope="col">피인용횟수</th>
										<th scope="col">KCI IF<br/>(2년, 자기인용제외)</th>
										<th scope="col">KCI IF<br/>(2년)</th>
										<th scope="col">KCI IF<br/>(3년)</th>
										<th scope="col">KCI IF<br/>(4년)</th>
										<th scope="col">중심성지수</th>
										<th scope="col">즉시성지수</th>
									</tr>
									</thead>
									<tbody>
									{meta.kci_index && meta.kci_index.map((item, num) => {
										return (
											<tr key={num}>
												<td>{item.indicator_year}</td>
												<td>{item.total_items}</td>
												<td>{item.total_cites}</td>
												<td>{item.impact_no_self}</td>
												<td>{item.impact}</td>
												<td>{item.impact_3}</td>
												<td>{item.impact_4}</td>
												<td>{item.centrality}</td>
												<td>{item.immediacy}</td>
											</tr>
										)
									})}
									</tbody>
								</table>
							</div>
							}

							{(meta.jcr_index && meta.jcr_index.length > 0) &&
								<div className="hide print-show">
									<div className="d-flex align-items-center mb-3 mt-3">
										<button className={"btn-tab-nav mr-1 active-color-lightpurple active"}>JCR</button>
									</div>
									<div className="hide print-show">
										<div className="tab-data active">
											<table className="table table-lightgray">
												<colgroup>
													<col width="7%"/>
													<col width="10%"/>
													<col width="10%"/>
													<col width="10%"/>
													<col width="12.6%"/>
													<col width="12.6%"/>
													<col width="12.6%"/>
													<col width="12.6%"/>
													<col width="12.6%"/>
												</colgroup>
												<thead>
												<tr>
													<th scope="col">Year</th>
													<th scope="col">Total<br/>Citie</th>
													<th scope="col">JIF</th>
													<th scope="col">5 year JIF</th>
													<th scope="col">Immediacy<br/>Index</th>
													<th scope="col">Article<br/>Influence Score</th>
													<th scope="col">Eigenfactor<br/>Score</th>
													<th scope="col">보정 IF</th>
													<th scope="col">보정 ES</th>
												</tr>
												</thead>
												<tbody>
												{meta.jcr_index && meta.jcr_index.map((item, num) => {
													return (
														<tr key={num}>
															<td>{item.indicator_year}</td>
															<td>{item.total_cites}</td>
															<td>{item.jif}</td>
															<td>{item.impact_5}</td>
															<td>{item.immediacy}</td>
															<td>{item.article_influence}</td>
															<td>{item.eigen_factor}</td>
															<td>{item.correct_impact}</td>
															<td>{item.correct_eigen}</td>
														</tr>
													)
												})}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							}
							{(meta.scopus_index && meta.scopus_index.length > 0) &&
								<div className="hide print-show">
									<div className="d-flex align-items-center mb-3 mt-3">
										<button className={"btn-tab-nav mr-1 active-color-lightorange active"}>Scopus</button>
									</div>
									<div className="hide print-show">
										<div className="tab-data active">
											<table className="table table-lightgray">
												<colgroup>
													<col width="7%"/>
													<col width="11%"/>
													<col width="10%"/>
													<col width="11%"/>
													<col width="12.2%"/>
													<col width="12.2%"/>
													<col width="12.2%"/>
													<col width="12.2%"/>
												</colgroup>
												<thead>
												<tr>
													<th scope="col">Year</th>
													<th scope="col">Percent Cited</th>
													<th scope="col">Cite Score</th>
													<th scope="col">Citation<br/>Count</th>
													<th scope="col">Scholarly<br/>Output</th>
													<th scope="col">SJR</th>
													<th scope="col">Top 10%</th>
													<th scope="col">SNIP</th>
												</tr>
												</thead>
												<tbody>
												{meta.scopus_index && meta.scopus_index.map((item, num) => {
													return (
														<tr key={num}>
															<td>{item.indicator_year}</td>
															<td>{item.percent_cited}</td>
															<td>{item.cite_score}</td>
															<td>{item.citation_count}</td>
															<td>{item.scholarly_output}</td>
															<td>{item.sjr}</td>
															<td>{item.top10}</td>
															<td>{item.snip}</td>
														</tr>
													)
												})}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							}
							{(meta.kci_index && meta.kci_index.length > 0) &&
								<div className="hide print-show">
									<div className="d-flex align-items-center mb-3 mt-3">
										<button className={"btn-tab-nav mr-1 active-color-lightgreen active"}>KCI</button>
									</div>
									<div className="hide print-show">
										<div className="tab-data active">
											<table className="table table-lightgray">
												<colgroup>
													<col width="7%"/>
													<col width="9%"/>
													<col width="9%"/>
													<col width="14%"/>
													<col width="12.2%"/>
													<col width="12.2%"/>
													<col width="12.2%"/>
													<col width="12.2%"/>
													<col width="12.2%"/>
												</colgroup>
												<thead>
												<tr>
													<th scope="col">Year</th>
													<th scope="col">논문수</th>
													<th scope="col">피인용횟수</th>
													<th scope="col">KCI IF<br/>(2년, 자기인용제외)</th>
													<th scope="col">KCI IF<br/>(2년)</th>
													<th scope="col">KCI IF<br/>(3년)</th>
													<th scope="col">KCI IF<br/>(4년)</th>
													<th scope="col">중심성지수</th>
													<th scope="col">즉시성지수</th>
												</tr>
												</thead>
												<tbody>
												{meta.kci_index && meta.kci_index.map((item, num) => {
													return (
														<tr key={num}>
															<td>{item.indicator_year}</td>
															<td>{item.total_items}</td>
															<td>{item.total_cites}</td>
															<td>{item.impact_no_self}</td>
															<td>{item.impact}</td>
															<td>{item.impact_3}</td>
															<td>{item.impact_4}</td>
															<td>{item.centrality}</td>
															<td>{item.immediacy}</td>
														</tr>
													)
												})}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							}
						</div>
					</>
				}
			</div>
		)
	}
};

export default JImpactFactor;
